import React, { Component, createRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./textTestimonial.css";
const teacherComments = [
  {
    name: "Lisa Mendoza, Daycare Owner Director",
    comment:
      "This training was eye-opening. I learned more in a few hours than I did in years of traditional emergency training.",
    certificated: true,
  },
  {
    name: "Rachel Collins, High School Teacher",
    comment:
      "Every educator should take this course. It gave me practical tools that I can use in my classroom immediately.",
  },
  {
    name: "Michael Trent, Charter School Director",
    comment:
      "We switched to AngelWatch from another program, and the difference is night and day. This is the best emergency training available.",
  },
  {
    name: "Jessica Ramirez, Preschool Teacher",
    comment:
      "After completing AngelWatch’s training, I finally feel like I know exactly what to do if an emergency happens.",
    certificated: true,
  },
  {
    name: "Emily Harris, Kindergarten Teacher",
    comment:
      "After taking the AngelWatch course, I finally feel prepared for any emergency—and that peace of mind is truly priceless.",
  },
  {
    name: "Lauren Mitchell, Kindergarten Teacher",
    comment:
      "This is the best training I’ve seen in 25+ years of education. My staff feels confident and prepared.",
  },
  {
    name: "Karen Williams, Assistant Principal",
    comment:
      "I no longer feel anxious about emergencies at my school. AngelWatch has given us a system that actually works.",
    certificated: true,
  },
  {
    name: "Sarah O’Connor, Daycare Director",
    comment:
      "As a daycare owner, I need to ensure my staff is trained. AngelWatch not only meets state requirements but goes beyond to ensure real-world readiness.",
  },
  {
    name: "Michelle Adams, 5th Grade Teacher",
    comment:
      "In all my years of teaching, I’ve never taken a course this thorough and effective. It truly stands out above the rest.",
  },
  {
    name: "James Carter, Officer",
    comment:
      "AngelWatch is the most realistic, engaging, and effective safety training we’ve ever had. Every school should be using this program.",
  },
];

class TextTestimonial extends Component {
  constructor(props) {
    super(props);
    this.videoRefs = teacherComments.map(() => createRef());
    this.state = {
      currentlyPlaying: Array(teacherComments.length).fill(false),
    };
  }

  handlePlayPause = (index) => {
    this.videoRefs.forEach((ref, i) => {
      const video = ref.current;
      if (!video) return;

      if (i === index) {
        if (video.paused) {
          video.play().catch((e) => console.error("Video play error:", e));
          this.setState((prevState) => {
            const newState = Array(teacherComments.length).fill(false);
            newState[i] = true;
            return { currentlyPlaying: newState };
          });
        } else {
          video.pause();
          this.setState((prevState) => {
            const newState = [...prevState.currentlyPlaying];
            newState[i] = false;
            return { currentlyPlaying: newState };
          });
        }
      } else {
        video.pause();
      }
    });
  };

  render() {
    const responsive = {
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
        slidesToSlide: 1,
      },
      tablet: {
        breakpoint: { max: 1024, min: 769 },
        items: 2,
        slidesToSlide: 1,
      },
      mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 1,
        slidesToSlide: 1,
      },
    };

    return (
      <div className="course1">
        <Carousel
          responsive={responsive}
          autoPlaySpeed={1000}
          transitionDuration={500}
          infinite={true}
          arrows={true}
          customLeftArrow={<button className="custom-arrow left">{"<-"}</button>}
          customRightArrow={<button className="custom-arrow right">{"->"}</button>}
        >
          {teacherComments.map((resource, index) => (
            <div className="courseListItem1" key={index}>
              <div>
                <img
                  src={require("../../assets/img/five-star.png")}
                  className="courseList__Img1"
                ></img>
                <p className="courseListText1">&quot;{resource.comment}&quot;</p>
              </div>
              <p className="courseListTitle1">{resource.name}</p>
            </div>
          ))}
        </Carousel>
      </div>
    );
  }
}

export default TextTestimonial;
